<template>
  <div class="heads clear_fd">
    <h1 title="量势新能源" class="head_h1"></h1>
    <div class="head_nav">
      <ul class="clear_fd">
        <li v-for="(item,index) in nav" :key="index" :data-navid='item.id' class="nav_li posr ml40" @click="changeNav(item)">
          <p class="nav_li_txt">{{item.name}}
            <span :class='selectNav == item.id ? "wire" : "hide"'></span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'heads',
  props: ['selectNav1'],
  data () {
    return {
      selectNav: 0,
      activeName: 'first',
      nav: [
        {id: 5, name: "联系我们",path: 'relation'},
        {id: 4, name: "关于我们",path: 'about'},
        {id: 3, name: "平台管理",path: 'login'},
        {id: 2, name: "解决方案",path: 'solution'},
        {id: 1, name: "产品和服务",path: 'product'},
        {id: 0, name: "首页",path: 'index'},
      ]
    }
  },
  created(){
    var href = window.location.href;
    for(var i = 0; i < this.nav.length; i++) {
      if(href.indexOf(this.nav[i].path) > -1) {
        this.selectNav = this.nav[i].id;
        return true;
      }
    }
  },
  methods: {
    changeNav:function(item) { //  点击切换菜单
      var path = item.path;
      if(path == 'login') {
        if(location.origin == 'https://www.charge-i.cn'){//海南量势
          location.href = 'https://tenant.charge-i.cn/tenantconsole/index.html?#/login';
        }else{//量势tenant
          location.href = 'http://tenant.charge-i.com/tenantconsole/index.html#/login';
        }

        return true;
      }
      this.$emit("childNav", path);
    }
  },
  watch:{
    'selectNav1'(e){
      this.selectNav = e;
    }
  }
}
</script>

<style scoped>
.heads {
  position: absolute;
  top: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 20px 20%;
  box-sizing: border-box;
  z-index: 10;
}
.head_h1 {
  width: 198px;
  height: 47px;
  float: left;
  background: url('../../assets/logo.png');
}
.head_nav {
  width: 70%;
  float: right;
}
.nav_li {
  float: right;
  color: #ffffff;
}
.nav_li_txt {
  position: relative;
  height: 47px;
  line-height: 47px;
  box-sizing: border-box;
  font-size: 17px;
}
.wire {
  position: absolute;
  height: 1px;
  left: 0;
  right: 0;
  bottom: -20px;
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/views/heads.vue